<template>
  <div v-if="isLoading" class="invest-count-board__loading">
    <MyLoader />
  </div>

  <section v-else class="invest-count-board" aria-labelledby="invest-count-title">
    <h2 id="invest-count-title">투자 현황</h2>
    <div class="invest-count-board__grid">
      <div class="status-item">
        <p>투자중<Tooltip :text="'투자금을 모집 중이며 마감 시간이 지나지 않은 상품입니다. 투자취소가 가능한 상태입니다.'" /></p>
        <strong>{{ myCnt.cntWaiting | commaFormat }}</strong>
      </div>
      <div class="status-item">
        <p>투자마감<Tooltip :text="'투자금 모집이 완료되었거나 마감 시간이 지난 상품입니다. 투자취소가 불가능한 상태입니다.'" /></p>
        <strong>{{ myCnt.cntDoneInvest | commaFormat }}</strong>
      </div>
      <button class="status-item status-item--link" type="button" @click="summaryCountClick('상환중')">
        <span>상환중</span><strong>{{ myCnt.cntRepay | commaFormat }}</strong>
      </button>
      <button class="status-item status-item--link status-item--overdue" type="button" @click="summaryCountClick('연체')">
        <span>연체</span><strong>{{ myCnt.cntOverdue | commaFormat }}</strong>
      </button>
      <button class="status-item status-item--link" type="button" @click="summaryCountClick('부실')">
        <span>부실</span><strong>{{ myCnt.totalInsolvent | commaFormat }}</strong>
      </button>
      <button class="status-item status-item--link" type="button" @click="summaryCountClick('상환완료')">
        <span>상환완료</span><strong>{{ (myCnt.cntDoneRepay + myCnt.cntEarlyRepayment) | commaFormat }}</strong>
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { InvestmentTypes } from '@/store/types/investment'
import MyLoader from '@/components/MyLoader.vue'
import Tooltip from '@/components/common/Tooltip.vue'

export default {
  components: {
    MyLoader,
    Tooltip,
  },
  computed: {
    ...mapGetters('investment', {
      isLoading: InvestmentTypes.getters.GET_USER_CNT_LOADING,
      myCnt: InvestmentTypes.getters.GET_USER_CNT,
    }),
  },
  methods: {
    summaryCountClick(status) {
      this.$router.push({
        name: 'myfunda-invest-list',
        query: { filter: status },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.invest-count-board__loading {
  min-height: 224px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.invest-count-board {
  padding: 24px 22px 12px;
}

.invest-count-board h2 {
  margin: 0 0 17px;
  color: #1a2330;
  font-size: 16px;
  font-weight: 700;
}

.invest-count-board__grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}

.status-item {
  min-height: 166px;
  padding: 39px 8px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: 0;
  border-right: 1px solid #f0f3f6;
  color: #5a6675;
  font: inherit;
  text-align: center;
}

.status-item:last-child {
  border-right: 0;
}

.status-item p,
.status-item span {
  margin: 0;
  color: inherit;
  font-size: 13.5px;
  font-weight: 500;
}

.status-item strong {
  color: #1a2330;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.status-item--link {
  cursor: pointer;
}

.status-item--link:hover span,
.status-item--link:hover strong {
  color: #0090c4;
}

.status-item--overdue strong,
.status-item--overdue:hover span,
.status-item--overdue:hover strong {
  color: #ec3a5e;
}

@media screen and (max-width: 959px) {
  .invest-count-board {
    padding: 21px 8px 8px;
  }

  .invest-count-board h2 {
    margin-left: 12px;
    font-size: 15px;
  }

  .invest-count-board__grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .status-item {
    min-height: 145px;
    padding: 34px 6px 27px;
    border-bottom: 1px solid #f0f3f6;
  }

  .status-item:nth-child(3n) {
    border-right: 0;
  }

  .status-item:nth-last-child(-n + 3) {
    border-bottom: 0;
  }

  .status-item strong {
    font-size: 22px;
  }
}
</style>
